<template>
  <vx-tooltip :text="$t(type) | toUpperCaseFirst" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      :type="dndStatus === type ? 'filled' : 'border'"
      v-if="dndStatus === type || dndStatus === ''"
      @click="process(type)">
      <i :class="iconClass"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'CtiDnd',
  props: {
    type: {
      type: String,
      required: true
    },
    server: {
      required: true
    },
    isDisplay: {
      default: false
    }
  },
  computed: {
    dndStatus () {
      return this.$store.getters.dndStatus
    },
    iconClass () {
      switch (this.type) {
      case 'rest':
        return 'c-icon-rest'
      case 'lunch':
        return 'c-icon-lunch'
      case 'after':
        return 'c-icon-after'
      default:
        return ''
      }
    },
    extension () {
      return this.$store.getters.extension
    }
  },
  methods: {
    async process (type) {
      if (this.isDisplay) {
        return
      }

      if (type === this.dndStatus) {
        await Cti.processDnd(this.server.domain, {
          id: type,
          data: this.extension,
          option: 2
        })
        this.$store.dispatch('updateDndStatus', '')
        this.$vs.notify({
          title:'CTI Notice',
          // text:`${this.$stringHelper.toUpperCaseFirst(type)} disabled`,
          text: this.$t(`${type}_disabled`),
          color:'success',
          position:'top-right'
        })
      } else {
        await Cti.processDnd(this.server.domain, {
          id: type,
          data: this.extension,
          option: 1
        })
        this.$store.dispatch('updateDndStatus', type)
        this.$vs.notify({
          title:'CTI Notice',
          // text:`${this.$stringHelper.toUpperCaseFirst(type)} enabled`,
          text: this.$t(`${type}_enabled`),
          color:'success',
          position:'top-right'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
